import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[sbDialogSidebar], [sb-dialog-sidebar], sb-dialog-sidebar',
  exportAs: 'sbDialogSidebar',
})
export class SbDialogSidebarDirective {
  @Input()
  sticky = true;

  @HostBinding('class')
  get hostClasses(): string {
    return `flex w-80 flex-col gap-4 text-sm shrink-0 ${this.sticky ? ' sticky top-0 min-h-fit h-full' : ''}`;
  }
}
